(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("ExamSelectionModalCtrl", ["examResource", "examQuestionResource", "$localStorage", "$scope",
        "$translate", "DTOptionsBuilder", "DTColumnDefBuilder", ExamSelectionModalCtrl]);
    function ExamSelectionModalCtrl(examResource, examQuestionResource, $localStorage, $scope, $translate, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dataLoaded = false;
        vm.questionsLoaded = false;
        vm.dtInstance = {};
        vm.dtSearch = "";
        vm.model = {
            exams: []
        };
        vm.questionsView = false;
        vm.defaultLocalization = $localStorage.tenantSettings.defaultLocalization.id;
        vm.examQuestions = [];
        vm.lang = $translate.proposedLanguage() || $translate.use();
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
            .withOption("processing", false)
            .withOption("responsive", { details: { type: "column" } })
            .withOption("stateSave", false)
            .withOption("stateDuration", -1)
            .withOption("order", [1, "asc"])
            .withPaginationType("full_numbers")
            .withOption("rowCallback", rowCallback)
            .withBootstrap();
        examResource.getExamSelectionModalExamsViewModal({ localizationId: vm.defaultLocalization }, function (model) {
            vm.model = model;
            vm.dataLoaded = true;
        });
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).withOption("class", "control").withOption("sortable", false).withOption("targets", 0)
        ];
        function rowCallback(nRow, aData) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $("td:not(.control)", nRow).unbind("click");
            $("td:not(.control)", nRow).bind("click", function () {
                $scope.$apply(function () {
                    $scope.$close({ name: aData[2], id: nRow.id });
                });
            });
            return nRow;
        }
        vm.dtOptionsQuestions = DTOptionsBuilder.newOptions()
            .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
            .withOption("processing", false)
            .withOption("responsive", { details: { type: "column" } })
            .withOption("stateSave", false)
            .withOption("stateDuration", -1)
            .withOption("order", [0, "asc"])
            .withPaginationType("full_numbers")
            .withBootstrap();
        vm.goToQuestions = function (number) {
            vm.questionsView = true;
            examQuestionResource.getExamSelectionModalQuestionsViewModel({ number: number }, function (model) {
                vm.examQuestions = model.questions;
                vm.questionsLoaded = true;
            });
        };
        vm.search = function () {
            vm.dtInstance.DataTable.search(vm.dtSearch).draw();
        };
        vm.back = function () {
            vm.questionsView = false;
            vm.examQuestions = [];
        };
    }
}());
